// PDP need help one

let overlayOne = document.querySelector(".custom-pdp-overlay-one")

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('.open-call')) {
  document.querySelector(".open-call").addEventListener("click", function () {
    document.getElementById("wrap").style.display = "block";
    overlayOne.style.display ="block"
  });
  }

  if (document.querySelector(".close-call")) {
  document.querySelector(".close-call").addEventListener("click", function () {
    document.getElementById("wrap").style.display = "none";
    overlayOne.style.display ="none" 
  });
  }

  document.addEventListener("click", function (event) {
    //console.log(event.target)  
      if(event.target===wrap){
         document.getElementById("wrap").style.display = "none";
         overlayOne.style.display ="none"
      }
     
  });
 
  

  $(".open-call").click(function () {
    $("body").css("overflow", "hidden");
  });
  $(".close-call").click(function () {
    $("body").css("overflow", "visible"); 
  });
  $("#wrap").click(function () {
    $("body").css("overflow", "visible");
  });
});
 

// PDP need help two
let overlayTwo = document.querySelector(".custom-pdp-overlay-two") 
let wrapTwo = document.getElementById("wrap-two")

document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".open-call-two")){
    document.querySelector(".open-call-two").addEventListener("click", function () {
      wrapTwo.style.display = "block";
      overlayTwo.style.display ="block"
    });
  }
  if(document.querySelector(".close-call-two")){
    document.querySelector(".close-call-two").addEventListener("click", function () {
      wrapTwo.style.display = "none";
      overlayTwo.style.display ="none"
    });
  }
    document.addEventListener("click", function (event) {
    console.log(event.target)  
      if(event.target==wrapTwo){  
         wrapTwo.style.display = "none";
         overlayTwo.style.display ="none"  
      }
     
  });

  $(".open-call-two").click(function () {
    $("body").css("overflow", "hidden");
  });
  $(".close-call-two").click(function () {
    $("body").css("overflow", "visible");
  });
  $("#wrap-two").click(function () {
    $("body").css("overflow", "visible");
  });
});

// PDP need help three
let overlayThree = document.querySelector(".custom-pdp-overlay-three") 
let wrapThree = document.getElementById("wrap-three")


document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".open-call-three")){
    document.querySelector(".open-call-three").addEventListener("click", function () {
      wrapThree.style.display = "block";
      overlayThree.style.display ="block"
    });
  }
  if(document.querySelector(".close-call-three")){
    document.querySelector(".close-call-three").addEventListener("click", function () {
      wrapThree.style.display = "none";
      overlayThree.style.display ="none"
    });
  }
document.addEventListener("click", function (event) {
    console.log(event.target)  
      if(event.target==wrapThree){  
         wrapThree.style.display = "none";
         overlayThree.style.display ="none"  
         
      }
     
  });
  
  $(".open-call-three").click(function () {
    $("body").css("overflow", "hidden");
  });
  $(".close-call-three").click(function () {
    $("body").css("overflow", "visible");
  });
  $("#wrap-three").click(function () {
    $("body").css("overflow", "visible");
  });
});
